export interface ToolTopicRule {
  id: string;
  terms: RegExp;
  reason: string;
  examples: { en: string; zh: string };
}
const escape = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/** Curated phrases are literal data; an English word must not match inside an unrelated word. */
export function topic(
  id: string,
  en: string,
  zh: string,
  reason: string,
  exampleEn: string,
  exampleZh: string,
): ToolTopicRule {
  const english = en
    .split('|')
    .sort((a, b) => b.length - a.length)
    .map((word) => `\\b${escape(word)}${word.endsWith('s') ? '' : 's?'}\\b`);
  const chinese = zh.split('|').map(escape);
  return {
    id,
    terms: new RegExp([...english, ...chinese].join('|'), 'i'),
    reason,
    examples: { en: exampleEn, zh: exampleZh },
  };
}
